import React, { PureComponent } from 'react';
import { Button, Form, message } from "antd";
import { getInput, getInputRules } from "@/utils/tool"
import styles from './actionPopver.module.less';


const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 12 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
    }
};

class ActionPopver extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: {}
        }
    }

    componentDidMount() {
        // this.loadDefaultValue()
    }

    loadDefaultValue = () => {
        const { loadDefaultValue, deviceId, action, form } = this.props;
        const data = { id: deviceId, actionId: action.id }
        new Promise(resolve => {
            loadDefaultValue(data, resolve)
        }).then(defaultValue => {
            form.setFieldsValue(defaultValue)
        })
    }


    handleSubmit(e) {
        e.preventDefault();
        const { action, onSubmit, form, deviceId } = this.props;
        if (!action.id) return message.error('没有操作id')
        form.validateFields((err, values) => {
            if (!err) {
                const data = {
                    deviceId,
                    actionId: action.id,
                    actionCode: action.code,
                    params: {
                        actionId: action.id,
                        actionCode: action.code,
                        ...values
                    }
                }
                onSubmit && onSubmit(data)
            }
        });
    }

    render() {
        const { form, action, defaultValue = {}, title = '设置参数' } = this.props;
        const { paramList = [] } = action || {}
        const { getFieldDecorator } = form;
        let isSw;
        return (
            <React.Fragment>
                <div className={styles.title}>{title}</div>
                <Form {...formItemLayout} onSubmit={e => this.handleSubmit(e)}>
                    {paramList.map(item => {
                        isSw = item.code.endsWith('Sw');//是否是开关
                        const initialValue = '' + (defaultValue[item.code] || {})[isSw ? 'defValue' : 'value']
                        return <FormItem
                            key={item.code}
                            label={item.name}
                        >{getFieldDecorator(item.code, {
                            initialValue,
                            rules: getInputRules(item)
                        })
                            (getInput(item))
                            }</FormItem>
                    })}


                    <div style={{ height: '0.3rem' }}>
                        <Button style={{ float: 'right', marginRight: '0.08rem' }} type="primary" htmlType="submit"
                            icon="check"> 提交 </Button>
                        <Button style={{ float: 'right', marginRight: '0.12rem' }} type="primary" icon="redo"
                            onClick={this.loadDefaultValue}>恢复默认</Button>
                    </div>

                </Form>
            </React.Fragment>
        )
    }

}

export default Form.create()(ActionPopver);